export default __webpack_public_path__ + "static/media/vision-image-1.4eec83a2.jpg";